import styled from 'styled-components';

export const ContainerCard = styled.div`
  margin: 5px;
`;
